<script>
  import SignaturePad from "signature_pad";
  import { onMount, tick } from "svelte/internal";

  let pad;
  let canvas;

  // data will be the dataURL of signature or undefined if empty
  let data;

  export let value;

  // input[name]
  export let name;
  // input[id]
  export let id;
  // canvas[class]
  let className;
  export { className as class };

  function resizeCanvas() {
    var ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
    pad.clear(); // otherwise isEmpty() might return incorrect value
  }

  function reset() {
    pad.clear();
    data = undefined;
  }

  onMount(() => {
    pad = new SignaturePad(canvas, {
      backgroundColor: "rgb(255,255,255)",
      onEnd: () => {
        data = pad.toDataURL();
      },
    });
    if (value) {
      pad.fromDataURL(value);
      data = value;
    }
    window.addEventListener("resize", resizeCanvas);
    resizeCanvas();
    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  });
</script>

<style>
  .wrapper,
  canvas {
    width: 100%;
    height: 100%;
  }
  .delete-button {
    top: 0;
    right: 0;
  }
  .line {
    bottom: 1rem;
    border-bottom: 2px black solid;
    z-index: 2;
    width: 90%;
    left: 5%;
  }
</style>

<div class="position-relative wrapper">
  <input type="hidden" {name} {id} value={data} />
  <button
    class="btn btn-sm position-absolute delete-button"
    type="button"
    on:click|preventDefault={reset}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-trash-2">
      <polyline points="3 6 5 6 21 6" />
      <path
        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0
        0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  </button>
  <div class="line position-absolute" />
  <canvas bind:this={canvas} class={className} />
</div>
